"use client";

import { useState } from "react";

import { userIcon } from "@public/icons";
import Link from "next/link";
import { useAuth } from "@src/contexts/AuthContext";
import AlertModal from "../Modal/AlertModal";
import { toast } from "react-toastify";
import Image from "next/image";

const Dropdowns = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { removeToken } = useAuth();

  const confirmLogout = () => {
    removeToken();
    setShowModal(false);
    toast.success("با موفقیت از حساب خود خارج شدید");
  };

  const items = [
    {
      key: "1",
      label: (
        <Link href="/orders" onClick={() => setIsOpen(false)}>
          <p target="_blank" rel="noreferrer">
            سفارشات خرید
          </p>
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link href="/sell-orders" onClick={() => setIsOpen(false)}>
          <p target="_blank" rel="noreferrer">
            سفارشات فروش
          </p>
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link href="/address" onClick={() => setIsOpen(false)}>
          <p target="_blank" rel="noreferrer">
            آدرس‌های من
          </p>
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link href="/userInfo" onClick={() => setIsOpen(false)}>
          <p target="_blank" rel="noreferrer">
            اطلاعات کاربری
          </p>
        </Link>
      ),
    },
    {
      key: "5",
      label: (
        <div onClick={() => setShowModal(true)}>
          <p className="text-skyBlue" target="_blank" rel="noreferrer">
            خروج از حساب
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        className="relative transition-all"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <button
          className="flex items-center"
          type="button"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true"
        >
          <Image
            width={100}
            height={100}
            className="h-6 w-6 cursor-pointer"
            src={userIcon}
            alt="آیکون کاربر"
          />
        </button>
        <div
          className={`absolute left-0 z-60000 w-[130px] origin-top-right rounded-md border bg-white transition-all duration-300 ease-in-out ${
            isOpen ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div className="flex flex-col justify-center py-1 text-center" role="none">
            {items.map((item) => (
              <label
                key={item.key}
                className="block cursor-pointer px-4 py-2 text-sm text-gray-700 transition-all hover:bg-gray-100 hover:text-black"
                role="menuitem"
                tabIndex="-1"
              >
                {item.label}
              </label>
            ))}
          </div>
        </div>
      </div>

      <AlertModal
        showModal={showModal}
        toggleModal={() => setShowModal(!showModal)}
        content={
          <div className="text-center">
            <p>آیا از خروج از حساب کاربری مطمئن هستید؟</p>
            <div className="mt-4 flex justify-center gap-x-2">
              <button
                onClick={confirmLogout}
                className="bg-skyBlue mr-2 cursor-pointer rounded-sm px-4 py-2 text-white"
              >
                تایید
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="cursor-pointer rounded-sm bg-gray-300 px-4 py-2 text-black"
              >
                لغو
              </button>
            </div>
          </div>
        }
        modalTitle="خروج از حساب"
        modalSize="max-w-sm"
        iconType="warning"
      />
    </>
  );
};

export default Dropdowns;
